if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"mutationsImportApp","remotes":[{"alias":"mutationsApp","name":"mutationsApp","entry":"https://test.mutations.pensiondynamics.ch/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(1(03|41|48|55)|203|509|642|735|767)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"mutationsApp":[{"alias":"mutationsApp","name":"mutationsApp","entry":"https://test.mutations.pensiondynamics.ch/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}